module.exports = __webpack_public_path__ + "img/skd-light.b45bfad0.svg";